import script from "./customNoteToMixDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./customNoteToMixDetail.vue?vue&type=script&setup=true&lang=js"

import "./customNoteToMixDetail.vue?vue&type=style&index=0&id=4f9b25de&lang=less"

const __exports__ = script;

export default __exports__